export const execAsync = async <T>(promise: PromiseLike<T>): Promise<{ data: T | null, error: Error | null }> => {
	try {
		const data: T = await promise;
		return { data, error: null };
	} catch (e) {
		return { data: null, error: e };
	}
};
